(function () {
  const { lang } = document.body;
  if (!lang) return;

  const button = document.querySelector([`[data-lang="${lang}"]`]);
  if (!button) return;

  button.classList.add('active');

  const currentLang = document.querySelector('.current-language');
  currentLang.textContent = button.textContent;

})();
